<template>
    <div>
      <b-container class=".container">
        <!-- Título da página -->
        <b-row class="my-4">
          <b-col>
            <h3>Notas Fiscais</h3>
          </b-col>
          <b-col cols="auto" class="text-right action-btns">
            <router-link :to="'/emitir-nota-fiscal'"><b-button variant="primary" @click="emitirNota">Emitir NFS-e</b-button></router-link>
            <b-button @click="updateList"><i class="fa fa-refresh"></i> Atualizar Lista</b-button>
          </b-col>
        </b-row>
  
        <!-- Filtros de busca -->
        <b-row class="mb-3">
          <b-col>
            <b-form-input v-model="search" placeholder="Busque pelo número da nota"></b-form-input>
          </b-col>
          <b-col cols="auto" class="filters">
            <b-form-select v-model="month" :options="months" style="width: auto;"></b-form-select>
            <b-form-select v-model="year" :options="years"></b-form-select>
          </b-col>
        </b-row>
        <!-- Adicionar isLoading -->
         <p v-if="loading">Carregando...</p>
          <!-- Tabela de notas -->
          <b-table v-if="filteredInvoices.length > 0" :items="filteredInvoices" :fields="fields" responsive>
            <!-- Slot personalizado para a coluna 'detalhes' -->
            <template #cell(invoice)="data">
            <!-- Exemplo de formatação do JSON dentro da célula -->
            <div class="d-flex flex-column justify-content-center">
                <span style="display: block;"><strong>{{ data.item.invoice.datetime }}</strong></span>
                <span v-if="data.item.invoice.number" style="display: block;"><strong>Número:</strong> {{ data.item.invoice.number }}</span>
                <span v-if="data.item.invoice.verification_code" style="display: block;"><strong>Cód. Verificação:</strong> {{ data.item.invoice.verification_code }}</span>
                <span style="display: block;"><strong>Código Interno:</strong> {{ data.item.invoice.code }}</span>
            </div>
            </template>
            <!-- Slot personalizado para a coluna 'customere' -->
            <template #cell(customer)="data">
            <!-- Exemplo de formatação do JSON dentro da célula -->
            <div class="d-flex flex-column justify-content-center">
                <span style="display: block;">{{ data.item.customer.name }}</span>
                <span style="display: block;">{{ data.item.customer.cpf_cnpj.length == 11 ? formatCPF(data.item.customer.cpf_cnpj) : formatCNPJ(data.item.customer.cpf_cnpj) }}</span>
            </div>
            </template>
            <template #cell(service)="data">
              <div class="d-flex flex-column justify-content-center">
                <span style="display: block;">{{ data.item.service.description }}</span>
                <span style="display: block;"><strong>Valor:</strong> R$ {{ data.item.service.value | formatPrice }}</span>
              </div>
            </template>
            <template #cell(status)="data">
              <span :class="['status-badge', getStatusClass(data.item.status)]">
                {{ data.item.status }}
              </span>
            </template>
            <template #cell(actions)="data">
              <div v-if="data.item.status == 'Emitida' || data.item.status == 'Cancelada'">
                <select v-model="data.item.selectedAction" @change="handleActionChange(data)" class="select-action" size="md">
                  <option value="" disabled selected>Selecione</option>
                  <option value="see" :data-invoice="data.item.invoice.url">Visualizar</option>
                  <option value="duplicate" :data-invoice="data.item.invoice.number">Duplicar</option>
                  <!-- <option value="issueCharge" disabled :data-email="data.item.customer.email">Emitir Cobrança</option>-->
                  <option value="cancel" :data-invoice="data.item.invoice.number">Cancelar</option>
                </select>
              </div>
            </template>
          </b-table>
          <p v-if="filteredInvoices.length == 0 && !loading && !search">Nenhuma nota fiscal encontrada neste período.</p>
          <p v-if="filteredInvoices.length == 0 && !loading && search">Nenhuma nota fiscal encontrada com este número.</p>
        </b-container>
    </div>
</template>
  
<script>
import axios from 'axios';

  export default {
    data() {
      return {
        loading: false,
        selectedAction: '',
        invoices: [],
        search: '',
        search: '', // Filtro de busca por número de nota
        month: new Date().getMonth() + 1, // Mês selecionado
        year: new Date().getFullYear(), // Ano selecionado
        activeTab: 0, // Aba ativa das notas
        months: [
          { value: '', text: 'Mês' },
          { value: 1, text: 'Janeiro' },
          { value: 2, text: 'Fevereiro' },
          { value: 3, text: 'Março' },
          { value: 4, text: 'Abril' },
          { value: 5, text: 'Maio' },
          { value: 6, text: 'Junho' },
          { value: 7, text: 'Julho' },
          { value: 8, text: 'Agosto' },
          { value: 9, text: 'Setembro' },
          { value: 10, text: 'Outubro' },
          { value: 11, text: 'Novembro' },
          { value: 12, text: 'Dezembro' }
        ],
        fields: [
          { key: 'invoice', label: 'Nota' },
          { key: 'customer', label: 'Cliente', sortable: true },
          { key: 'service', label: 'Serviço' },
          { key: 'status', label: 'Situação' },
          { key: 'actions', label: 'Ações' }
        ],
      }
    },
    mounted() {
      this.updateList();
    },
    computed: {
      filteredInvoices() {
        if (!this.search) {
          // Se não houver busca, exibe todos os invoices
          return this.invoices;
        }

        // Caso contrário, filtra pelos números dos invoices
        return this.invoices.filter(invoice =>
          invoice.invoice.number && invoice.invoice.number.includes(this.search)
        );
      },
      years() {
        /* 
          Gera os anos desde 2024 - quando a emissão de notas fiscais foi
          implantada no sistema - até o ano atual 
        */
        const currentYear = new Date().getFullYear();  // Obtém o ano atual
        const yearsArray = [{ value: '', text: 'Ano' }];  // Primeiro item com "Ano"
        
        for (let year = 2024; year <= currentYear; year++) {
          yearsArray.push({ value: year, text: year.toString() });
        }''
        
        return yearsArray;
      },
    },
    methods: {
      // Atualiza a lista de notas ao clicar em "Atualizar Lista"
      async updateList() {
        this.toggleLoading();

        const filters = {
          month: this.month || null,
          year: this.year || null
        };

        try {
          const response = await axios.post('/financial/invoices/', { obj: filters });

          // Usando Promise.all para resolver todas as Promises de forma assíncrona
          this.invoices = await Promise.all(response.data.map(async (invoice) => {
            // Verifica se o status do invoice é 'processando_autorizacao'
            let status = invoice.status;
            let consultResult = '';

            if (status === 'processando_autorizacao' || status == 'Processando') {
              // Chama a função consultInvoice apenas se o status for 'processando_autorizacao'
              consultResult = await this.consultInvoice(invoice.pk).then((response) => {
                return response.data;
              });
              // Se o resultado for 'Emitida', envia os pdfs do relatório de timesheet
              // e nota de reembolso, se tiver.
              if (consultResult.status == 'Emitida') {
                axios.post(`/financial/financial/${invoice.pk}/send_timesheet_report_and_refund_note_pdfs/`)
              }
            }

            return {
              invoice: {
                pk: invoice.pk,
                url: consultResult ? consultResult.url : invoice.url,
                datetime: invoice.datetime,
                number: consultResult ? consultResult.number : invoice.number,
                verification_code: consultResult ? consultResult.verification_code : invoice.verification_code,
                code: invoice.code
              },
              customer: {
                name: invoice.customer.name,
                cpf_cnpj: invoice.customer.cpf_cnpj,
                email: invoice.customer.email
              },
              service: {
                description: invoice.service.description,
                value: invoice.service.value
              },
              status: consultResult ? consultResult.status : invoice.status,
              selectedAction: ''
            };
          }));
        } catch (error) {
          this.toggleLoading()
          this.$snotify.error('Erro ao carregar as notas fiscais. Tente novamente ou fale com o suporte.', 'Erro', {
            timeout: 4000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true
          });
        }

        this.toggleLoading();
      },
      toggleLoading() {
        this.loading = !this.loading
      },
      getStatusClass(status) {
        // Retorna a classe Bootstrap com base no status
        switch (status) {
          case "Emitida":
            return "bg-success text-white"; // Verde
          case "Cancelada":
            return "bg-danger text-white"; // Vermelho
          case "Não autorizada":
            return "bg-warning text-dark"; // Amarelo
          case "Processando":
            return "bg-info text-white"; // Azul claro
          default:
            return "bg-secondary text-white"; // Cinza para outros casos
        }
      },
      handleActionChange(data) {
        const action = data.item.selectedAction;
        const invoice = data.item

        switch (action) {
          case 'see':
            this.seeInvoice(invoice.invoice.url);
            break;
          case 'duplicate':
            this.duplicateInvoice(invoice.invoice.pk);
            break;
          case 'issueCharge':
            this.issueCharge(invoice.customer.email);
            break;
          case 'cancel':
            this.cancelInvoice(invoice.invoice.pk);
            break;
          default:
            break;
        }

        data.item.selectedAction = '' 
      },
      async seeInvoice(invoiceUrl) {
        try {
          window.open(invoiceUrl, '_blank');
        } catch(error) {
          this.$snotify.error('Erro ao carregar a visualização da nota. Tente novamente, ou fale com o suporte.', 'Erro', {
            timeout: 4000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true
          });
        }
      },
      async consultInvoice(invoicePk) {
        return await axios.post(`/financial/invoices/${invoicePk}/consult_invoice/`)
      },
      // Função para duplicar uma nota
      duplicateInvoice(invoicePk) {
        // Pega o host atual: https://www.pgsa.com.br
        const host = window.location.origin;

        // Constrói a URL para emitir a nota fiscal
        const url = `${host}/app/emitir-nota-fiscal/?duplicate=${invoicePk}`;

        window.open(url, '_blank')
      },
  
      // Função para emitir cobrança
      async issueCharge(customerEmail) {
        return
        //const response = await axios.post('api/send_email/', )
      },
  
      cancelInvoice(pk) {
        this.$swal.fire({
          title: 'Cancelar Nota Fiscal',
          text: 'Deseja realmente cancelar esta nota?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          focusCancel: true
        }).then((result) => {
          // Pega a justificativa para o cancelamento
          if (result.value) {
            this.$swal({
            title: 'Justificativa para Cancelamento',
            text: 'Por favor, forneça uma justificativa para o cancelamento da nota:',
            input: 'textarea',
            inputPlaceholder: 'Escreva sua justificativa...',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Enviar',
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
              if (!value) {
                return 'A justificativa não pode estar vazia!';
              }
            },
            allowOutsideClick: false, // Impede o fechamento ao clicar fora
          }).then((result) => {
            if (result.value) {
               // Pega o valor do input
              const justification = result.value;

              // Se a justificativa não estiver vazia, envia para o backend
              if (justification) {
                axios
                  .post(`/financial/invoices/${pk}/cancel/`, { 'justification': justification })
                  .then((response) => {
                    const canceled = response.data.status && response.data.status == 'cancelado'
                    const alreadyCanceled = response.data.codigo && response.data.codigo == 'nfe_cancelada'
                    const cancellationError = response.data.status && response.data.status == 'erro_cancelamento'

                    if (canceled) {
                      this.$swal('Nota fiscal cancelada', 'Nota fiscal cancelada com sucesso.', 'success');
                    } else if (alreadyCanceled) {
                      this.$swal('Nota fiscal já cancelada', 'Essa nota fiscal já foi cancelada.', 'warning');
                    } else if (cancellationError) {
                      this.$swal('Erro ao cancelar nota', response.data.error, 'error'); 
                    }
                  })
                  .catch((error) => {
                    this.$swal('Erro', 'Ocorreu um erro ao cancelar essa nota fiscal. Tente novamente, ou fale com o suporte.', 'error');
                  });
              } else {
                this.$swal('Erro', 'Por favor, forneça uma justificativa.', 'error');
              }
            }
          }) 
          }
        })
      },
      formatDate(dateObject) {
        // Acessa o dia, mês e ano diretamente do objeto date
        const day = String(dateObject.getDate()).padStart(2, '0');  // PadStart garante 2 dígitos
        const month = String(dateObject.getMonth() + 1).padStart(2, '0');  // Mês é zero-indexed, então soma-se 1
        const year = dateObject.getFullYear();

        // Retorna a data no formato dd/mm/yyyy
        return `${day}/${month}/${year}`;
      },
      formatCPF(cpf) {
        // Remove todos os caracteres não numéricos
        cpf = cpf.replace(/\D/g, '');
        
        // Aplica o formato com pontos e traço
        if (cpf.length === 11) {
          return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        }
        
        // Se o CPF não tiver 11 dígitos, retorna o próprio número (não formatado)
        return cpf;
      },
      formatCNPJ(cnpj) {
        // Remove todos os caracteres não numéricos
        cnpj = cnpj.replace(/\D/g, '');
        
        // Aplica o formato com pontos, barra e traço
        if (cnpj.length === 14) {
          return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        }
        
        // Se o CNPJ não tiver 14 dígitos, retorna o próprio número (não formatado)
        return cnpj;
      }
    },
    watch: {
      month() {
        this.updateList();
      },
      year() {
        this.updateList();
      }
    }
  }
  </script>
  
<style scoped>
.readonly-input {
  background-color: transparent;  
  border: none;                   
  color: inherit;                                  
  padding: 0;                       
  user-select: none;               
  outline: none; 
  pointer-events: none;                               
}
.select-action {
  color: #555;
  background-color: white !important;
  border: 1px solid #ccc !important;
  height: 34px;
  border-radius: .25rem;
  padding: 6px 12px;
  font-size: 14px;
}
.btn-secondary {
  background-color: white !important;
}
.container {
  max-width: 100% !important;
  background-color: white !important;
  padding-top: 1rem !important;
  padding-bottom: 4rem !important;
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.action-btns {
  display: flex;
  gap: 1rem;
}
.filters {
  display: flex;
  gap: 1rem;
  justify-content: start;
}
.table-actions {
  width: 150px;
}
.status-badge {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  border-radius: 1rem;
  font-weight: bold;
}
</style>